import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Apex Rénovation';
const BASE_URL = 'https://apexrenovation.fr';
const DEFAULT_DESC = 'Artisans rénovation maison et commerce à Châteauroux. Rénovation intérieure, cuisine, salle de bain, isolation, toiture, façade dans le Berry (Indre 36). Garantie décennale. Devis gratuit.';

export default function PageSEO({ title, description, path = '' }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Artisans Rénovation Châteauroux | Indre (36)`;
  const desc = description || DEFAULT_DESC;
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
}
